import * as React from 'react';
import Popover, { PopoverInteractionType, PopoverContentDisplayMode, PopoverLayerPosition, PopoverBoundariesElement } from '@doordash/component-popover';
import MenuControl from './MenuControl.js';
import { MenuAlignment, MenuInteractionType, MenuSize, MenuSelectPosition, MenuSelectType, MenuTitleAlignment } from './types.js';
import MenuItemWrapper from './MenuItemWrapper.js';
import { MenuContainer } from './styles.js';
import { Spacing } from '@doordash/design-language';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Menu = function Menu(_ref) {
  var _ref$alignMenu = _ref.alignMenu,
      alignMenu = _ref$alignMenu === void 0 ? MenuAlignment.BottomRight : _ref$alignMenu,
      _ref$isInline = _ref.isInline,
      isInline = _ref$isInline === void 0 ? true : _ref$isInline,
      _ref$interactionType = _ref.interactionType,
      interactionType = _ref$interactionType === void 0 ? MenuInteractionType.ToggleClick : _ref$interactionType,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? MenuSize.Medium : _ref$size,
      boundariesElement = _ref.boundariesElement,
      content = _ref.content,
      controlText = _ref.controlText,
      defaultIsVisible = _ref.defaultIsVisible,
      isVisible = _ref.isVisible,
      menuContainerStyles = _ref.menuContainerStyles,
      onControlClick = _ref.onControlClick,
      _onVisibilityChange = _ref.onVisibilityChange,
      renderMenuControl = _ref.renderMenuControl,
      setContentWidthAsControlWidth = _ref.setContentWidthAsControlWidth;
  return /*#__PURE__*/React.createElement(Popover, {
    boundariesElement: boundariesElement,
    interactionType: PopoverInteractionType[interactionType],
    defaultIsVisible: defaultIsVisible,
    isVisible: isVisible,
    onVisibilityChange: function onVisibilityChange(isVisible) {
      return _onVisibilityChange && _onVisibilityChange(isVisible);
    },
    content: /*#__PURE__*/React.createElement(MenuContainer, {
      menuContainerStyles: menuContainerStyles,
      setContentWidthAsControlWidth: setContentWidthAsControlWidth
    }, content && content.map(function (contentItem, index) {
      return /*#__PURE__*/React.createElement(MenuItemWrapper, {
        key: "MenuItem-".concat(index),
        item: contentItem
      });
    })),
    contentDisplayMode: PopoverContentDisplayMode[isInline ? 'InlineFlex' : 'Flex'],
    position: PopoverLayerPosition[alignMenu],
    showContainerPointer: false,
    customOffset: [Spacing.None, Spacing.XxxSmall],
    setContentWidthAsAnchorWidth: setContentWidthAsControlWidth
  }, function (_ref2) {
    var accessibilityAttributes = _ref2.accessibilityAttributes,
        describedBy = _ref2.describedBy;

    if (renderMenuControl) {
      return renderMenuControl({
        accessibilityAttributes: _objectSpread(_objectSpread({}, accessibilityAttributes), {}, {
          'aria-expanded': interactionType === MenuInteractionType.Controlled ? isVisible : accessibilityAttributes['aria-expanded']
        }),
        describedBy: describedBy
      });
    }

    return /*#__PURE__*/React.createElement(MenuControl, {
      size: size,
      text: controlText ? controlText : '',
      isExpanded: interactionType === MenuInteractionType.Controlled ? isVisible : accessibilityAttributes['aria-expanded'],
      "aria-controls": accessibilityAttributes['aria-controls'],
      isInline: isInline,
      onClick: onControlClick
    });
  });
};

Menu.BoundariesElements = PopoverBoundariesElement;
Menu.InteractionTypes = MenuInteractionType;
Menu.MenuAlignments = MenuAlignment;
Menu.SelectPositions = MenuSelectPosition;
Menu.SelectTypes = MenuSelectType;
Menu.Sizes = MenuSize;
Menu.TitleAlignments = MenuTitleAlignment;

export { Menu as default };
